import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import * as PackageInventoryStore from '../../../redux/packageInventory';
import type { PackageVersionVulnerability } from '../../../../shared/organizationPackages';
import type { SortableColumn, SortType } from '../PackageVersion/types';

export function useSortedVulnerabilities(
  column: SortableColumn,
  sortType: SortType,
) {
  const vulnerabilities = useSelector(PackageInventoryStore.selectors.getVulnerabilities);

  return useMemo(() => {
    const compare = (vuln1: PackageVersionVulnerability, vuln2: PackageVersionVulnerability) => {
      const value1 = vuln1[column];
      const value2 = vuln2[column];
      if (value1 && value2) {
        if (value1 < value2) return -1;
        if (value1 > value2) return 1;
      }
      return 0;
    };

    const sorted = [...(vulnerabilities || [])].sort(compare);
    return sortType === 'asc' ? sorted : sorted.reverse();
  }, [vulnerabilities, column, sortType]);
}

export default useSortedVulnerabilities;
